// Small inline glyphs the design components use. Inline SVG rather than
// IonIcon so the components render (and test) without Ionic's loader.
import React from "react";

type Name = "clock" | "lock" | "star" | "check" | "warn" | "learner";

const PATHS: Record<Name, React.ReactNode> = {
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  lock: (<><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>),
  star: <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  warn: (<><path d="M12 3l9.5 17h-19z" /><path d="M12 10v4M12 17.5v.5" /></>),
  learner: <circle cx="12" cy="12" r="6" />
};

export function Glyph({ name, size = 12, title }: { name: Name; size?: number; title?: string }) {
  return (
    <svg className="icon-svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2}
      strokeLinecap="round" strokeLinejoin="round" role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      {title ? <title>{title}</title> : null}
      {PATHS[name]}
    </svg>
  );
}
